/*  MUI  */
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from '@mui/material';

/*  Components  */
// TODO: Fix dependency cycle - SAAS-992
// eslint-disable-next-line import/no-cycle
import { AdminApplication } from 'application/Home/Admin/Application/Dashboard';

/*  Shared  */
import { AppHeader } from 'application/Shared/Components/Headers/AppHeader';
import { TenantAppContextProvider } from 'application/Shared/Contexts/TenantAppContext';
import { Transition } from 'application/Shared/Helpers';

/* Flags */
import { INCIDENTS, hasFeature } from 'featureFlags/src';

/*  React  */
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/*  Internal Components  */
import { StatusBanner } from './internal/StatusBanner';

export const AdminAppModal = ({ applicationId, onCloseModal, open }) => {
    const { t } = useTranslation();

    // Effect to handle back button navigation
    useEffect(() => {
        if (!open) return undefined;

        // Create a history entry for the modal to buffer against the back button
        window.history.pushState(
            'modal-open',
            document.title,
            window.location.href
        );

        // Handle for the popstate event (triggered by back/forward navigation)
        const handlePopState = () => {
            onCloseModal();
        };

        // Add ecent lsitener for back button
        window.addEventListener('popstate', handlePopState);

        // Clean up event listener when component unmounts or modal closes
        return () => {
            window.removeEventListener('popstate', handlePopState);

            // If we are closing the modal, without using the back button,
            // remove the extra history entry we added
            if (window.history.state === 'modal-open') {
                window.history.back();
            }
        };
    }, [onCloseModal, open]);

    return (
        <TenantAppContextProvider applicationId={applicationId}>
            <Dialog
                data-trackid="sharedModalsAdminAppModalDialog"
                fullScreen
                PaperProps={{ style: { padding: 0 } }}
                onClose={() => onCloseModal()}
                open={open}
                TransitionComponent={Transition}
            >
                <DialogTitle sx={{ backgroundColor: 'background.tertiary' }}>
                    <AppHeader modalView onClose={onCloseModal} />
                </DialogTitle>
                <DialogContent
                    dividers
                    sx={{ backgroundColor: 'background.primary' }}
                >
                    {hasFeature(INCIDENTS) && (
                        <StatusBanner applicationId={applicationId} />
                    )}
                    <AdminApplication id={applicationId} modalView />
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        color="primary"
                        style={{ float: 'right' }}
                        onClick={() => onCloseModal()}
                    >
                        {t('Common.close')}
                    </Button>
                </DialogActions>
            </Dialog>
        </TenantAppContextProvider>
    );
};
